export const IOS_USER_AGENT_REGEX = /iPad|iPhone|iPod/;
export const ANDROID_USER_AGENT_REGEX = /android/i;
